export const ListQueryKey = 'bmdZxshs';
export const DetailQueryKey = 'bmdZxsh';

export const Urls = {
  selectUrl: '/bmdZxsh/list',
  updateUrl: '/bmdZxsh/update',
  deleteUrl: '/bmdZxsh/delete',
  createUrl: '/bmdZxsh/create',
  detailUrl: '/bmdZxsh/info',
};
